// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const MotionContract = contract({
  name: "Motion",
  description: "A directed sequence of scenes on one persistent stage — the",
  import: "@gradeui/ui",
  aliases: ["motion","grade motion","scenes","sequence","demo reel","product video","launch video","title card","lower third","section break","multi-scene","storyboard"],
  subcomponents: ["MotionScene","MotionScreen","MotionText"],
  composesWith: ["ScreenAnimator","ThreeScene","VideoPlayer","AppShell","the whole component set (scenes hold screens)"],
  styleDefaults: {"MotionScreen":"gds-motion-screen","MotionText":"gds-motion-text","MotionOverlay":"gds-motion-overlay","MotionSceneImpl":"gds-motion-scene","Motion":"gds-motion"},
  props: {
  "view": {
      schema: z.enum(["play", "strip"]).optional(),
      design: "knob",
      description: "play runs the film; strip lays",
      default: "play",
  },
  },
});
